var _circle, _path, _circle2, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgElectricboardPeople(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.9166,
    cy: 11.0833,
    r: 3.5,
    fill: "#46474C",
    stroke: "#46474C",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8333 16.9168H20.9999C22.6107 16.9168 23.9166 18.2227 23.9166 19.8335V21.4668C23.9166 21.5313 23.8644 21.5835 23.7999 21.5835H10.0333C9.96882 21.5835 9.91659 21.5313 9.91659 21.4668V19.8335C9.91659 18.2227 11.2224 16.9168 12.8333 16.9168Z",
    fill: "#46474C",
    stroke: "#46474C",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.0833,
    cy: 11.0833,
    r: 4.66667,
    fill: "#46474C",
    stroke: "#F7F7F8",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1667 15.7502H7C4.74484 15.7502 2.91667 17.5783 2.91667 19.8335V21.4668C2.91667 22.1756 3.49123 22.7502 4.2 22.7502H17.9667C18.6754 22.7502 19.25 22.1756 19.25 21.4668V19.8335C19.25 17.5783 17.4218 15.7502 15.1667 15.7502Z",
    fill: "#46474C",
    stroke: "#F7F7F8",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElectricboardPeople);
export default __webpack_public_path__ + "static/media/electricboard-people.acb33fee0280f2316cd04e6db2362e96.svg";
export { ForwardRef as ReactComponent };